export default __webpack_public_path__ + "static/media/help.450abe67.svg";